module.exports = {
	"characters": [
		{
			"name": "Escar",
			"img": "http://transfertsdepekin.fr/assets/players/escar.png",
			"age": "26 ans",
			"size": "1m81",
			"country": "brésilien",
			"role": "milieu offensif",
			"descr": "Vous êtes discret et vous souffrez du manque de reconnaissance que vous pouvez avoir. Pour y remédier vous acceptez de rejoindre un championnat où votre talent sera mieux valorisé. Petit conseil&nbsp;: évitez les restos allemands, vous n'avez toujours pas digéré votre dernière CurryWurst.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/escar.png\" target=\"_blank\">Télécharger son affiche</a>",
			"validate": {
				"1": "Vous venez de signer au Lin&nbsp;Go&nbsp;FC pour un salaire de 25&nbsp;M€ par an&nbsp;!",
				"2": "Préparez vos bagages, vous embarquez dès demain pour la Chine. Serez-vous à la hauteur de ce nouveau défi&nbsp;?"
			},
			"start": 25
		},
		{
			"name": "Lavezizi",
			"img": "http://transfertsdepekin.fr/assets/players/lavezizi.png",
			"age": "32 ans",
			"size": "1m73",
			"country": "argentin",
			"role": "attaquant",
			"descr": "Vous êtes un gros fêtard et votre dernière expérience parisienne vous a ruiné. Vous acceptez le challenge chinois pour renflouer votre compte en banque. Après tout, le challenge sportif ne vous a jamais intéressé dans votre carrière. Petit conseil lors de votre périple, pensez à brider votre humour&nbsp;!<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/lavezizi.png\" target=\"_blank\">Télécharger son affiche</a>",
			"validate": {
				"1": "Vous venez de signer au AS&nbsp;Fort&nbsp;Hun pour un salaire de 26&nbsp;M€ par an&nbsp;!",
				"2": "Préparez vos bagages, vous embarquez dès demain pour la Chine. Serez-vous à la hauteur de ce nouveau défi&nbsp;?"
			},
			"start": 26
		},
		{
			"name": "Gerbinho",
			"img": "http://transfertsdepekin.fr/assets/players/gerbinho.png",
			"age": "30 ans",
			"size": "1m79",
			"country": "ivoirien",
			"role": "ailier",
			"descr": "Vous êtes quelqu'un de fidèle mais votre dernière aventure romaine vous a laissé un goût amer. Pour oublier, vous vous jetez dans les bras d'une belle chinoise. Petit conseil, apprenez les rudiments capillaires locaux.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/gerbinho.png\" target=\"_blank\">Télécharger son affiche</a>",
			"validate": {
				"1": "Vous venez de signer au Peï&nbsp;Pet&nbsp;Olympic pour un salaire de 18&nbsp;M€ par an&nbsp;!",
				"2": "Préparez vos bagages, vous embarquez dès demain pour la Chine. Serez-vous à la hauteur de ce nouveau défi&nbsp;?"
			},
			"start": 18
		},
		{
			"name": "Witsal",
			"img": "http://transfertsdepekin.fr/assets/players/witsal.png",
			"age": "28 ans",
			"size": "1m86",
			"country": "belge",
			"role": "milieu de terrain",
			"descr": "Vous êtes protecteur et votre famille passe avant tout. Pour les mettre à l'abri, vous acceptez de changer vos Roubles en Yuan. Petit conseil&nbsp;: quittez le stade de la loose pour atteindre le zénith.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/witsal.png\" target=\"_blank\">Télécharger son affiche</a>",
			"validate": {
				"1": "Vous venez de signer au RC&nbsp;Kash&nbsp;Flô pour un salaire de 18&nbsp;M€ par an&nbsp;!",
				"2": "Préparez vos bagages, vous embarquez dès demain pour la Chine. Serez-vous à la hauteur de ce nouveau défi ?"
			},
			"start": 18
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/characters.json
// module id = 15
// module chunks = 0